// AgentBill SDK - Main Entry Point
export { AgentBillWrapper } from './wrapper';
export { AgentBillTracer } from './tracer';
export * from './types';
export * from './validation';

import { AgentBillWrapper } from './wrapper';
import type { AgentBillConfig } from './types';

/**
 * Initialize AgentBill SDK
 * 
 * @example
 * ```typescript
 * import { AgentBill } from 'agentbill-sdk';
 * import OpenAI from 'openai';
 * 
 * // Initialize with your API key
 * const agentBill = AgentBill.init({
 *   apiKey: 'your-api-key',
 *   customerId: 'customer-123',
 *   debug: true
 * });
 * 
 * // Wrap your OpenAI client
 * const openai = agentBill.wrapOpenAI(new OpenAI({
 *   apiKey: process.env.OPENAI_API_KEY
 * }));
 * 
 * // Use normally - automatic tracking
 * const response = await openai.chat.completions.create({
 *   model: 'gpt-4',
 *   messages: [{ role: 'user', content: 'Hello!' }]
 * });
 * ```
 */
export const AgentBill = {
  init: (config: AgentBillConfig) => new AgentBillWrapper(config)
};
